/* 手机号 */
export function validateMobile (str) {
    const reg = /^1(3|4|5|6|7|8|9)[0-9]{9}$/
    return reg.test(str)
}

/* 价格 */
export function validatePrice (str) {
    const reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
    return reg.test(str)
}

/* 检验密码是含有小写字母、大写字母、数字、特殊符号的两种及以上  6-16位组合新密码 */
export function validateCombinationPwd(str) {
    const reg = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,16}$/
    return reg.test(str)
}